export default __webpack_public_path__ + "static/media/dealYCFunding.2bdeb33a.png";